import { createSelector } from '@reduxjs/toolkit';
import { initialState } from '.';

export const selectCommonFunctionSlice = state =>
  state.commonFunction || initialState;

export const selectCommonFunction = createSelector(
  [selectCommonFunctionSlice],
  state => state,
);

export const selectInstallHeaderVisible = createSelector(
  [selectCommonFunctionSlice],
  state => state.showInstallHeader,
);

export const selectIsClientDomain = createSelector(
  [selectCommonFunctionSlice],
  state => state.isClientDomain,
);

export const selectIsDemoDataActive = createSelector(
  [selectCommonFunctionSlice],
  state => state.isDemoDataActive,
);
